/* global Survey, grecaptcha */
import { getMarae } from "./config/marae";
import { request, ENDPOINTS } from "./config/api";
import { createSurveyConfig } from "./utility/create-survey-config";
import { dobToISO } from "./utility/date";
import { initMaraePicker } from "./maraePicker";

require("./myBootstrapDatepicker");
require("./addressFinderWidget");

let postData;

initMaraePicker();

async function sendData(survey) {
    const marae = await getMarae();
    const surveyData = survey.data;
    const data = {};
    const interactions = [];
    let links = [];
    data.dob = dobToISO(surveyData.dob);

    [
        "title",
        "firstName",
        "surname",
        "gender",
        "phone",
        "cell",
        "email",
        "occupation",
    ].forEach((attribute) => {
        data[attribute] = surveyData[attribute];
    });

    // Address
    ["line1", "line2", "suburb", "city", "postcode"].forEach((attribute) => {
        data[attribute] = surveyData.address[attribute];
    });

    if (surveyData.marae === "aua") {
        interactions.push({ value: `Land block ${surveyData.landBlock}` });
    } else if (surveyData.marae.marae && surveyData.marae.takiwa) {
        const hapuName = `hapu${surveyData.marae.marae.replace(/[ ()]/g, "")}`;
        const maraeItem = Object.values(marae).find(
            (item) => item.description === surveyData.marae.marae
        );
        const hapuItem =
            maraeItem.hapu.length === 1
                ? maraeItem.hapu[0]
                : maraeItem.hapu.find((item) => {
                      return surveyData[hapuName] === item.description;
                  });

        if (hapuItem) {
            links = [
                ...links,
                {
                    type: "hapu",
                    id: hapuItem.id,
                    value: hapuItem.description,
                },
                {
                    type: "marae",
                    id: maraeItem.id,
                    value: maraeItem.description,
                },
                {
                    type: "takiwa",
                    value: surveyData.marae.takiwa,
                    id: Number(surveyData.marae.takiwaId),
                },
            ];
        } else {
            console.error("Could not get hapū", surveyData);
        }

        if (
            surveyData.secondaryMarae &&
            surveyData.secondaryMarae.marae &&
            surveyData.secondaryMarae.takiwa
        ) {
            const secondaryHapuName = `secondaryHapu${surveyData.secondaryMarae.marae.replace(
                /[ ()]/g,
                ""
            )}`;
            const secondMaraeItem = Object.values(marae).find(
                (item) => item.description === surveyData.secondaryMarae.marae
            );
            const secondHapuItem =
                secondMaraeItem.hapu.length === 1
                    ? secondMaraeItem.hapu[0]
                    : secondMaraeItem.hapu.find((item) => {
                          return (
                              surveyData[secondaryHapuName] === item.description
                          );
                      });

            if (secondHapuItem) {
                interactions.push({
                    value: `Secondary Takiwā: ${surveyData.secondaryMarae.takiwa}, secondary marae: ${secondMaraeItem.description}, secondary hapū: ${secondHapuItem.description}`,
                });
                // TODO: Add secondary hapu
                // links = [
                //     ...links,
                //     {
                //         type: "hapu",
                //         id: secondHapuItem.id,
                //         value: secondHapuItem.description,
                //     },
                //     {
                //         type: "marae",
                //         id: secondMaraeItem.id,
                //         value: secondMaraeItem.description,
                //     },
                //     {
                //         type: "takiwa",
                //         id: Number(surveyData.secondaryMarae.takiwaId),
                //         value: surveyData.secondaryMarae.takiwa,
                //     },
                // ];
            } else {
                console.error("Could not get secondary hapū", surveyData);
            }
        } else {
            console.error("Incorrect secondary marae information", surveyData);
        }
    } else {
        console.error("Incorrect marae information", surveyData);
    }

    ["spouse", "industry", "qualifications", "aka", "referrer"].forEach(
        (attribute) => {
            if (surveyData[attribute]) {
                interactions.push({
                    value: `${
                        attribute[0].toUpperCase() + attribute.slice(1)
                    }: ${surveyData[attribute]}`,
                });
            }
        }
    );

    if (surveyData.signed) {
        links.push({
            type: "attachment",
            value: surveyData.signed,
        });
    }

    if (surveyData.preferredContact) {
        interactions.push({
            value: `Preferred Contact: ${surveyData.preferredContact}`,
        });
    }

    const aliases = [];

    if (surveyData.aka) {
        aliases.push(surveyData.aka);
    }

    if (surveyData.maidenName) {
        aliases.push(`${surveyData.firstName} ${surveyData.maidenName}`);
    }

    if (surveyData.maidenName) {
        links.push({
            type: "aliases",
            value: aliases,
        });
    }

    if (surveyData.tereo) {
        interactions.push({ value: `Te Reo Māori: ${surveyData.tereo}` });
    }

    for (let i = 1; i <= surveyData.tamarikiCount; i++) {
        const tamaiti = surveyData[`tamaiti${i}`];
        const gender = surveyData[`tamaiti${i}Gender`];
        const dob = surveyData[`tamaiti${i}Dob`];
        interactions.push({
            value: `Tamaiti ${i}: ${tamaiti} ${gender} ${dob}`,
        });
    }

    addWhakapapa(surveyData, interactions, "whakapapa_");

    postData = {
        tenant: "RANGI",
        data,
        interactions,
        links,
    };

    // console.log(survey.data);
    // console.log(postData);
    // console.log(JSON.stringify(survey.data));
    // console.log(JSON.stringify(postData));

    grecaptcha.execute();
}

function addWhakapapa(data, list, base) {
    const whaea = `${base}w`;
    const matua = `${base}m`;
    if (data[whaea]) {
        list.push({ value: `${whakapapaString(whaea)}: ${data[whaea]}` });
        addWhakapapa(data, list, whaea);
    }
    if (data[matua]) {
        list.push({ value: `${whakapapaString(matua)}: ${data[matua]}` });
        addWhakapapa(data, list, matua);
    }
}

function whakapapaString(fullIdentifier) {
    let identifier = fullIdentifier.replace(/^whakapapa_/, ""),
        ret = "";
    while (identifier.length) {
        const lastTupuna = identifier[identifier.length - 1];
        identifier = identifier.slice(0, identifier.length - 1);
        if (lastTupuna === "w") {
            if (ret) {
                ret = `mother's ${ret}`;
            } else {
                ret = "mother";
            }
        } else if (lastTupuna === "m") {
            if (ret) {
                ret = `father's ${ret}`;
            } else {
                ret = "father";
            }
        } else {
            console.error(
                `Unrecognised whakapapa identifier ${fullIdentifier}`
            );
        }
    }

    return ret[0].toUpperCase() + ret.slice(1);
}

function onSubmit(token) {
    postData.recaptcha = token;

    request.post(ENDPOINTS.register, postData);
}

Survey.StylesManager.applyTheme("bootstrap");
Survey.defaultBootstrapCss.navigationButton = "btn btn-primary";
Survey.surveyLocalization.locales.my = {
    pageNextText: "Haere / Next",
    pagePrevText: "Hoki / Previous",
    completeText: "Mutu / Complete",
    completingSurvey:
        "Tino Pai - Thank you for registering, we will be in touch with you in due course.",
    progressText: "{0} / {1}",
};
Survey.FunctionFactory.Instance.register("whakapapaVisible", whakapapaVisible);
Survey.FunctionFactory.Instance.register("maraeVisible", maraeVisible);

async function startRegister() {
    const surveyJSON = await createSurveyConfig();

    $("#register-intro").hide();
    const survey = new Survey.Model(surveyJSON);
    $("#surveyContainer").Survey({
        model: survey,
        onComplete: sendData,
    });

    survey.showProgressBar = "top";
    survey.locale = "my";
}

function maraeVisible(params) {
    if (params && params[0]) {
        return params[0].marae === params[1];
    }
}

function whakapapaVisible(params) {
    return Boolean(params[0]);
}

window.onSubmit = onSubmit;
window.startRegister = startRegister;
